import React from "react"
import CarIcon from "@mui/icons-material/DirectionsCar"
import CircularProgress from "@mui/material/CircularProgress"

export default function CarIconLoader() {
  return (
    <div
      style={{
        height: 100,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        marginBottom: 20,
      }}
    >
      <CarIcon
        style={{
          position: "absolute",
          fontSize: 64,
        }}
        color="primary"
        className="car-animation"
      />
      <CircularProgress
        size={100}
        color="secondary"
        style={{ position: "absolute" }}
      />
    </div>
  )
}
